Customer.Dashboard ||= {}

class Customer.Ticket.MassiveActionsView extends Backbone.View
  template: JST["backbone/templates/customer/dashboard/summary/main/header/massive_actions"]

  events:
    'click #actions': '_onActions'

  initialize: (@options = {}) ->
    @model = @options.model
    @includeNotLoaded = @options.includeNotLoaded
    @total = @options.total
    @totalLoaded = @model.totalLoaded().length
    @loadedSelectedTickets = @model.selected().length
    @massiveSelectedTicketsView = new Customer.Ticket.MassiveSelectedTicketsView(
      total: @total, totalLoaded: @totalLoaded, loadedSelectedTickets: @loadedSelectedTickets, includeNotLoaded: @includeNotLoaded
    )

  render: ->
    @massiveUpdateView = new Customer.Dashboard.MassiveUpdateView(@options)
    @$el.html(@template())
    @$el.find('.massive-selected-tickets').append(@massiveSelectedTicketsView.render().el)
    @$el.append(@massiveUpdateView.render().el)
    @

  remove: () ->
    @massiveSelectedTicketsView.remove()
    @massiveSelectedTicketsView = undefined

    @massiveUpdateView.remove()
    @massiveUpdateView = undefined
    super

  updateCountWithLoaded: (total, selected) ->
    @massiveSelectedTicketsView.updateSelectLoaded(total, selected)
    if @massiveUpdateView
      @massiveUpdateView.updateCountWithLoaded()

  updateCountWithNotLoaded: ->
    @massiveSelectedTicketsView.updateSelectNotLoaded()
    if @massiveUpdateView
      @massiveUpdateView.updateCountWithNotLoaded()

  _onActions: ->
    @_keepCustomerSessionAlive()
    @massiveUpdateView.show()

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'
